// Not extending BaseType because resource does not return timestamp from API.
export default class Resource {
  id = 0;

  name = '';
}
